import React from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { Form, FormSelectOption } from "@carrotfertility/carotene-core-x"
import { StepButtons } from "#/components/carrot-card-cost-share/steps/shared/StepButtons"
import { FormRadioButtonGroup } from "#/services/common-forms"

export interface RadioGroupStepProps {
  title: string
  description?: string | React.ReactNode
  name: string
  options: FormSelectOption[]
  onSubmit: (formValues: { [key: string]: string }) => void
  defaultValue?: string
  onChange?: (formValues: { [key: string]: string }) => void
}

export function RadioGroupStep({
  title,
  description,
  name,
  options,
  onSubmit,
  defaultValue
}: RadioGroupStepProps): JSX.Element {
  const { back } = useStateMachine()
  return (
    <Box>
      <Typography id={`${name}-title`} variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.sm })}>
        {title}
      </Typography>

      <Typography sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.md })}>{description}</Typography>

      <Form onSubmit={onSubmit} defaultValues={{ [name]: defaultValue }}>
        <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.tokens.spacing.xl })}>
          <FormRadioButtonGroup name={name} aria-labelledby={`${name}-title`} options={options} />
          <StepButtons selectName={name} back={back} />
        </Box>
      </Form>
    </Box>
  )
}
